import { SxProps, Theme } from '@mui/material/styles'

export const boldBlueHeader: SxProps<Theme> = {
  color: 'primary.main',
  fontWeight: 600,
}
